import React from 'react';
import Skeleton from '@/components/ui/Skeleton/Skeleton';
import CardSkeleton from './QuestionCards/CardSkeleton';
import HeaderSkeleton from './HeaderSkeleton';

const GradingSkeleton = () => (
  <>
    <div className="tw-py-4 tw-flex tw-items-center tw-justify-between">
      <Skeleton height="tw-h-8" width="tw-w-80" />
    </div>
    <HeaderSkeleton />
    <CardSkeleton />
    <CardSkeleton />
    <CardSkeleton />
  </>
);

export default GradingSkeleton;
